import React from 'react';
import { MapPin, Instagram, Calendar } from 'lucide-react';
import { salonInfo } from '../data/mockData';

export const Contact = () => {
  return (
    <section id="contact" className="section-padding bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="section-title mb-4">
            Kontakt
          </h2>
          <p className="section-subtitle">
            Besuche uns oder buche direkt online deinen Termin
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Address */}
            <div className="contact-info-card">
              <div className="flex items-start space-x-4">
                <div className="contact-icon-container">
                  <MapPin className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-2">Adresse</h3>
                  <p className="text-gray-700">
                    {salonInfo.address.street}<br />
                    {salonInfo.address.district}<br />
                    {salonInfo.address.postalCode} {salonInfo.address.city}
                  </p>
                  <a 
                    href={salonInfo.contact.googleMaps}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-accent hover:text-accent-dark font-semibold mt-2 inline-block"
                  >
                    Auf Google Maps ansehen →
                  </a>
                </div>
              </div>
            </div>

            {/* Instagram */}
            <div className="contact-info-card">
              <div className="flex items-start space-x-4">
                <div className="contact-icon-container">
                  <Instagram className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-2">Instagram</h3>
                  <p className="text-gray-700 mb-2">
                    Folge uns für Inspiration und Updates
                  </p>
                  <a 
                    href={salonInfo.contact.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-accent hover:text-accent-dark font-semibold"
                  >
                    @ginosfriseure →
                  </a>
                </div>
              </div>
            </div>

            {/* Booking */}
            <div className="contact-info-card">
              <div className="flex items-start space-x-4">
                <div className="contact-icon-container">
                  <Calendar className="w-6 h-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg mb-2">Online Termin buchen</h3>
                  <p className="text-gray-700 mb-4">
                    Buche deinen Termin schnell und einfach über Treatwell
                  </p>
                  <a 
                    href={salonInfo.contact.treatwell}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary inline-block"
                  >
                    Jetzt buchen
                  </a>
                </div>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="contact-info-card">
              <h3 className="font-bold text-lg mb-4">Öffnungszeiten</h3>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Montag:</span>
                  <span className="font-semibold">{salonInfo.hours.monday}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Dienstag:</span>
                  <span className="font-semibold">{salonInfo.hours.tuesday}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Mittwoch:</span>
                  <span className="font-semibold">{salonInfo.hours.wednesday}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Donnerstag:</span>
                  <span className="font-semibold">{salonInfo.hours.thursday}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Freitag:</span>
                  <span className="font-semibold">{salonInfo.hours.friday}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Samstag:</span>
                  <span className="font-semibold">{salonInfo.hours.saturday}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Sonntag:</span>
                  <span className="font-semibold">{salonInfo.hours.sunday}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2498.6304187!2d6.7779!3d51.2383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8ca5b1b1b1b1b%3A0x1b1b1b1b1b1b1b1b!2sParkstra%C3%9Fe%204%2C%2040477%20D%C3%BCsseldorf!5e0!3m2!1sde!2sde!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ginos Friseure Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};
